import axios from "../axios";
import api from "../api";

export const state = {
  config: {},
  reports: {},
  missingData: {},
  loading: new Set()
}

export const mutations = {
  SET_PODCAST_CHARTS_STATE (state, { key, value }) {
    state[key] = value
  },
  SET_PODCAST_CHARTS_LOADING (state, { key, value }) {
    value ? state.loading.add(key) : state.loading.delete(key)
  }
}

export const actions = {
  async get_podcast_charts_reports ({ commit }, payload) {
    try {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'get_podcast_charts_reports', value: true })
      const { data } = await axios.post(api.podcastCharts.reports, payload)
      commit('SET_PODCAST_CHARTS_STATE', { key: 'reports', value: data })
    } catch (error) {
      console.log(error)
    } finally {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'get_podcast_charts_reports', value: false })
    }
  },

  async get_podcast_charts_missing_data ({ state, commit }) {
    try {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'get_podcast_charts_missing_data', value: true })
      const { data } = await axios.get(api.podcastCharts.missingData)
      commit('SET_PODCAST_CHARTS_STATE', { 
        key: 'missingData', 
        value: data
      })
    } catch (error) {
      console.log(error)
    } finally {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'get_podcast_charts_missing_data', value: false })
    }
  },

  async get_podcast_charts_platform_missing_data ({ state, commit }, { platform, week, year }) {
    try {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'get_podcast_charts_platform_missing_data', value: true })
      const { data } = await axios.post(`${api.podcastCharts.missingData}/${platform}`, {
        week,
        year
      })
      commit('SET_PODCAST_CHARTS_STATE', { 
        key: 'missingData', 
        value: { 
          ...state.missingData, 
          platforms: {
            ...state.missingData.platforms, 
            [platform]: data
          } 
        } 
      })
    } catch (error) {
      console.log(error)
    } finally {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'get_podcast_charts_platform_missing_data', value: false })
    }
  },

  async get_podcast_charts_config ({ commit }) {
    try {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'get_podcast_charts_config', value: true })
      const { data } = await axios.get(api.podcastCharts.config)
      const { _rev, ...config } = data // TODO: update BE not to send _rev
      commit('SET_PODCAST_CHARTS_STATE', { key: 'config', value: config })
    } catch (err) {
      console.log(err)
    } finally {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'get_podcast_charts_config', value: false })
    }
  },

  async update_podcast_charts_config ({ state, commit }) {
    try {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'update_podcast_charts_config', value: true })
     await axios.put(api.podcastCharts.config, state.config)
    } catch (err) {
      console.log(err)
    } finally {
      commit('SET_PODCAST_CHARTS_LOADING', { key: 'update_podcast_charts_config', value: false })
    }
  }
}